export default "__VITE_ASSET__D3vv0T2___"